// ---------------------------------------------------------------------------
// Client configuration.
//
// Everything here is inlined into the bundle by Vite and is public by design.
// The security boundary is RLS, not key secrecy (PLAN 2.5). The resolution
// rules live in config.ts, which is pure and tested.
// ---------------------------------------------------------------------------

import { resolveConfig } from './config';

const config = resolveConfig(import.meta.env);

export const env = {
  supabaseUrl: config.supabaseUrl,
  supabaseAnonKey: config.supabaseAnonKey,
  /**
   * The basemap ships with the app rather than living on R2: the Yucaipa
   * extract is 2.9 MB, well under the 25 MB Cloudflare Pages per-file cap that
   * PLAN 3 gave as the reason for a separate bucket, and same-origin removes
   * the CORS configuration PLAN 7 warns is the silent failure mode. Set
   * VITE_PMTILES_URL to an absolute URL to host it elsewhere.
   */
  pmtilesUrl: config.pmtilesUrl,
  /**
   * Glyphs are local too. From a third-party origin they would not render
   * offline, leaving a canvasser with an unlabelled map -- worse than no map,
   * since street names are the whole point at a door.
   */
  glyphsUrl: config.glyphsUrl,
} as const;

/** Non-empty means the app cannot run; App renders these instead of booting. */
export const envProblems: readonly string[] = config.problems;
